import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { getBrand, getBrandConfig, getEnvironment } from './app/shared/services';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

const brandConfig = getBrandConfig();
document.documentElement.setAttribute('data-brand', getBrand());
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', brandConfig.favicon);
document.title = brandConfig.displayName;

if (getEnvironment().production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) =>
  console.error(err),
);
